import { gql } from 'apollo-angular';

export default gql`
  query ListTenants {
    listTenants {
      id
      name
      parent_id
      profile
      tenant_ref
      does_own_modelling
      workshop_milling_tenant_id
      workshop_milling_tenant_ref
      workshop_milling_tenant_name
      workshop_printing_tenant_id
      workshop_printing_tenant_ref
      workshop_printing_tenant_name
    }
  }

  query ListWorkshopTenants {
    listWorkshopTenants {
      id
      name
    }
  }

  query ListTenantParents {
    listTenantParents {
      id
      name
      parent_id
      profile
      tenant_ref
      does_own_modelling
      workshop_milling_tenant_id
      workshop_milling_tenant_ref
      workshop_milling_tenant_name
      workshop_printing_tenant_id
      workshop_printing_tenant_ref
      workshop_printing_tenant_name
    }
  }

  query ListTenantsByWorkshopTenantId($workshop_tenant_id: ID!) {
    listTenantsByWorkshopTenantId(workshop_tenant_id: $workshop_tenant_id) {
      city
      country
      does_own_modelling
      house_number
      id
      name
      postal_code
      profile
      street
      tenant_ref
    }
  }

  mutation CreateTenant($input: CreateTenantInput!) {
    createTenant(input: $input) {
      id
      name
    }
  }
`;
